const UNASSIGNED_ID_PATTERN = /^lr-(\d+)$/;

/**
 * 未割当 id（`lr-{legRunId}`）の集合を legRun ID の数値配列に変換する。
 *
 * Why not startsWith('lr-') + parseInt(slice(3)): 配車済みカードの id は
 * `lr-{truckId}-{rotation}-{legRunId}` 形式（ConvenienceDispatches/Presenter.tsx:411）
 * を取りうり、parseInt 版だと先頭の truckId を legRun ID として通してしまう。
 * 正規表現で `lr-{数字}` 完全一致のみ許可し、それ以外は捨てる。
 */
export function parseUnassignedIds(ids: Iterable<string>): number[] {
  const result: number[] = [];
  for (const id of ids) {
    const m = UNASSIGNED_ID_PATTERN.exec(id);
    if (m) result.push(parseInt(m[1], 10));
  }
  return result;
}
